module.exports = "/static-assets/_next/static/images/logo-52f2d38e8510ae806e8d9ab46f9b3d05.png";